import React, {useEffect} from 'react';
import * as S from './Popup.styles';
import PopupHeader from './PopupHeader/PopupHeader';
import {AGREEMENT_PAGE_URL} from '../../../../constants/index';
import OtpBlock from './OtpBlock/OtpBlock';
import AccountDetails from './AccountDetails/AccountDetails';
import SupportingDocument from './SupportingDocument/SupportingDocument';
import CreatePassword from './CreatePassword/CreatePassword';
import AlmostDone from './AlmostDone/AlmostDone';
import AccountCreated from './AccountCreated/AccountCreated';

const PopUp = ({step, showPop, editNumber, child, showBackButton = true}) => {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
  }, []);

  return (
    <>
      {(showPop && (
        <S.PopupMainWrap>
          <S.PopContentWrap>
            {showBackButton && <PopupHeader step={step} editNumber={editNumber} />}
            {child}
          </S.PopContentWrap>
        </S.PopupMainWrap>
      )) ||
        null}
    </>
  );
};

export default PopUp;
